export { BvlFormTextareaComponent as BvlFormTextarea } from './form-textarea.component';
export { BvlFormTextareaModule } from './form-textarea.module';
